import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';
import type { FontFamily } from '../types/FontFamily';

export function composeFontFamilyClasses(family: Adaptive<FontFamily>): string {
    if (typeof family === 'object') {
        return clsx(
            family.base && `font-${family.base}`,
            family.sm && `sm:font-${family.sm}`,
            family.md && `md:font-${family.md}`,
            family.lg && `lg:font-${family.lg}`,
            family.xl && `xl:font-${family.xl}`,
            family['2xl'] && `2xl:font-${family['2xl']}`
        );
    }

    return `font-${family}`;
}
